export default {
    getGuideList: `${process.env.node}/guide/getGuideList`,
    addGuide: `${process.env.node}/guide/addGuide`,
    deleteGuide: `${process.env.node}/guide/deleteGuide`,
    updateGuide: `${process.env.node}/guide/updateGuide`,
    getPageMapping: `${process.env.node}/guide/adPageMapping`
}



// WEBPACK FOOTER //
// ./src/api/config/advertManage.js